"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _escape = _interopRequireDefault(require("lodash/escape"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = {
  escape: _escape.default
};

var _default = function _default(obj) {
  var __t,
      __p = '',
      __e = _.escape;

  __p += '\n<li class="zotero-group' + __e(obj.expand ? ' zotero-group-expanded' : '') + '" aria-expanded="' + __e(obj.expand ? 'true' : 'false') + '" role="listitem">\n\n	<h2 class="zotero-group-title" data-trigger="expand-group">' + __e(obj.title) + '</h2>\n	' + ((__t = obj.renderer.renderItems(obj.items)) == null ? '' : __t) + '\n</li>';
  return __p;
};

exports.default = _default;